import { useTheme } from '@mui/material';
import Odometer from 'odometer';
import 'odometer/themes/odometer-theme-default.css';
import { useEffect, useRef, useState } from 'react';
import { primaryFont } from 'src/theme/typography';

// eslint-disable-next-line react/prop-types
export default function AnimatedCounter({ target, sx = {} }) {
  const theme = useTheme();

  const odometerRef = useRef(null);
  const [inView, setInView] = useState(false);

  const handleScroll = () => {
    if (odometerRef.current) {
      const rect = odometerRef.current.getBoundingClientRect();
      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        setInView(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (inView && odometerRef.current) {
      const odometer = new Odometer({
        el: odometerRef.current,
        value: 0,
        theme: 'default',
        duration: 2000,
      });
      odometer.update(target);
    }
  }, [inView, target]);

  return (
    <div
      ref={odometerRef}
      style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        textAlign: 'center',
        fontFamily: primaryFont,
        ...sx,
      }}
    >
      0
    </div>
  );
}
